import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Bell, Check, CheckCheck } from 'lucide-react';
import api from '@/lib/api';

export default function Notifications() {
  const [notifs, setNotifs] = useState([]);

  useEffect(() => {
    api.get('/notifications').then(r => setNotifs(r.data)).catch(() => {});
  }, []);

  const markRead = async (id) => {
    await api.put(`/notifications/${id}/read`);
    setNotifs(prev => prev.map(n => n.notification_id === id ? { ...n, is_read: true } : n));
  };

  const markAllRead = async () => {
    await api.put('/notifications/read-all');
    setNotifs(prev => prev.map(n => ({ ...n, is_read: true })));
  };

  const typeColor = { info: 'text-[#007FFF]', success: 'text-[#009543]', warning: 'text-orange-500', error: 'text-[#CE1021]' };

  return (
    <div className="max-w-2xl mx-auto space-y-6 animate-fade-in" data-testid="notifications-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>Notifications</h1>
          <p className="text-muted-foreground text-sm mt-1">{notifs.filter(n => !n.is_read).length} non lue(s)</p>
        </div>
        {notifs.some(n => !n.is_read) && (
          <Button variant="outline" size="sm" onClick={markAllRead} data-testid="mark-all-read-btn">
            <CheckCheck className="w-4 h-4 mr-1" /> Tout marquer lu
          </Button>
        )}
      </div>

      {notifs.length === 0 ? (
        <Card className="border">
          <CardContent className="p-8 text-center">
            <Bell className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground">Aucune notification</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-2">
          {notifs.map(n => (
            <Card key={n.notification_id} className={`border transition-colors ${!n.is_read ? 'bg-[#007FFF]/5 border-[#007FFF]/20' : ''}`}>
              <CardContent className="p-4 flex items-start gap-3">
                <div className={`w-2 h-2 rounded-full mt-2 shrink-0 ${!n.is_read ? 'bg-[#007FFF]' : 'bg-transparent'}`} />
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-medium ${typeColor[n.type] || ''}`}>{n.title}</p>
                  <p className="text-sm text-muted-foreground mt-0.5">{n.message}</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {n.created_at ? new Date(n.created_at).toLocaleString('fr-FR') : ''}
                  </p>
                </div>
                {!n.is_read && (
                  <Button variant="ghost" size="sm" onClick={() => markRead(n.notification_id)} data-testid={`mark-read-${n.notification_id}`}>
                    <Check className="w-4 h-4" />
                  </Button>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
